// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__iMo2S","header":"ReportDetails_header__o-gjE","title":"ReportDetails_title__2urtn","left":"ReportDetails_left__TYVcO"};